export const checkObservationFormType = (
	observationType?: IObservationType
): "user" | "store" => {
	if (
		observationType === "INDIVIDUAL" ||
		observationType === "GREAT_CONVERSATION"
	)
		return "user";

	return "store";
};
